import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { FC } from 'react';

export const IconPause: FC<PropsWithClassProps> = ({ classProps }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 6 8" className={classProps?.root}>
      <path
        d="M1 0a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1m5 1v6a1 1 0 0 1-2 0V1a1 1 0 0 1 2 0"
        fill="currentColor"
      />
    </svg>
  );
};
